// PasswordInput.js
import React, { useState } from 'react';
import { IconButton, InputAdornment, OutlinedInput, FormControl, InputLabel } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const PasswordInput = ({ value, onChange, placeholder, name, autocomplete = 'current-password', required }) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <FormControl variant="outlined" fullWidth margin="normal">
      <InputLabel>{placeholder}</InputLabel>
      <OutlinedInput
        type={showPassword ? 'text' : 'password'}
        name={name}
        value={value}
        onChange={onChange}
        label={placeholder}
        autoComplete= {autocomplete}
        sx = {{fontSize: '1.0rem', m:0, p:0, pr:1 }}
        required
        inputProps={{ autoCapitalize: "none" }} // <-- Add this line
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={toggleShowPassword} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

export default PasswordInput;
